import React, { useRef } from 'react';
import { useToggleRefinement } from 'react-instantsearch';
import qs from 'qs';
import { updateSearchRefFromUrl } from './utils';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';
import { getSession, SessionStorageKeys } from '../../../utils/sessionStorage';

interface SaleItemsProps {
  label: string;
  setCurrentSaleItems: any;
  nbSaleItems: number;
  trackingInfo: any;
  attribute: string;
  on?: string;
  defaultRefinement?: any;
}
const SaleItems = ({ label, setCurrentSaleItems, nbSaleItems, trackingInfo }: SaleItemsProps) => {
  const { value, refine } = useToggleRefinement({ attribute: 'onPromotion' });
  const currentRefinement = value && value.isRefined;
  const searchState = qs.parse(window.location.search.slice(1)) as any;
  const searchRef = useRef(searchState);

  const ToggleCheck = event => {
    const currentRefinement = event.target.checked;
    const filters = Object.keys(searchState)
      .filter(key => !['query', 'page', 'hitsPerPage', 'sortBy'].includes(key))
      .reduce((obj, key) => {
        if (key.toLowerCase() === 'price') {
          obj[key.toLowerCase()] = { type: 'range', value: searchState[key] };
        } else {
          obj[key.toLowerCase()] = Array.isArray(searchState[key])
            ? searchState[key].map(i => ({ type: 'checkbox', value: i }))
            : { type: 'checkbox', value: searchState[key] };
        }
        return obj;
      }, {});

    setCurrentSaleItems(currentRefinement);
    refine({ isRefined: !currentRefinement });

    updateSearchRefFromUrl(searchRef);

    pushToDataLayer({
      event: currentRefinement ? 'select_filter' : 'unselect_filter',
      filter_group: 'Price',
      filter_name: 'sale items',
      filter_type: 'checkbox',
      filter_value: 'sale items',
      search_type: getSession(SessionStorageKeys.SearchMethod) || 'site search',
      search_term: searchState?.query || '',
    });

    window.dataLayer.push({
      event: 'custom.filter.set',
      group: 'site search',
      category: 'search',
      label: currentRefinement ? 'on' : 'off',
      name: 'saleItems',
      value: currentRefinement,
      info: {
        element: 'checkbox',
        position: trackingInfo.position,
        sortyBy: searchRef.current.sortBy || trackingInfo.defaults.sortBy,
        hitsPerPage: Number(searchRef.current.hitsPerPage) || trackingInfo.defaults.hitsPerPage,
      },
      newFilters: {
        ...filters,
        saleItems: {
          type: 'checkbox',
          value: currentRefinement ? 'on' : 'off',
        },
      },
      oldFilters: filters,
    });
  };

  return (
    <label className={`sale-items ${nbSaleItems === 0 && `hidden`}`}>
      <input type="checkbox" onChange={ToggleCheck} checked={currentRefinement} />
      {label}
      <span> ({nbSaleItems})</span>
    </label>
  );
};

export default SaleItems;
